export const CATEGORIA_DISTRIBUICAO_LUCROS = 'Distribuição de Lucros';

export const CATEGORIAS_EXCLUIDAS_DESPESAS_OPERACIONAIS = [
  CATEGORIA_DISTRIBUICAO_LUCROS,
  'Distribuição de Lucro',
];

export function isDespesaOperacional(categoria?: string | null): boolean {
  return !CATEGORIAS_EXCLUIDAS_DESPESAS_OPERACIONAIS.includes(categoria || '');
}

export function isDistribuicaoLucros(categoria?: string | null): boolean {
  return !isDespesaOperacional(categoria);
}
